import HorizontalLayout from './HorizontalLayout';

export default HorizontalLayout;
